import 'core-js/features/object/entries';
import 'core-js/features/object/from-entries';

import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';

import App from './App';
import cognito from './constants/cognito';

import './index.css';

Amplify.configure(cognito);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);
